<template>
<div class="title">  
<h1>Search<span>Anime</span></h1>
</div>
</template>

<style>

@import url('https://fonts.googleapis.com/css2?family=Oi&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100&family=Oi&family=Syne+Mono&display=swap');

.title {
justify-content: center;
display: flex;
width: 100%;
}

.title h1 {
font-family: 'Oi', cursive;
}
.title h1 span {
font-family: 'Noto Sans JP', sans-serif;
background:  rgb(6, 48, 48);
font-size: 40px;
color: white;
padding: 10px;
border-radius: 5px;

}
</style>